import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { RouterStateSerializer, withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { StorageOption, withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { provideStore } from '@ngxs/store';
import { provideMarkdown } from 'ngx-markdown';
import { routes } from './app.routes';
import { CMBOT_STORAGE_KEYS } from './features/core/cm/state/cm.state.model';
import { LYACV_STORAGE_KEYS } from './features/core/cv1g/state/lya-cv.models';
import { httpInterceptor } from './interceptor.http';
import { KeycloakGnService } from './shared/services/keycloak-gn.service';
import { AppState } from './state/app.state';
import { CustomRouterStateSerializer } from './state/router.selectors';

// Charge le dictionnaire français (noms de jours/mois) pour le pipe `date: ... : 'fr-FR'`.
registerLocaleData(localeFr, 'fr-FR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideMarkdown(),
    provideStore(
      [AppState],
      withNgxsRouterPlugin(),
      withNgxsStoragePlugin({
        storage: StorageOption.LocalStorage,
        keys: [...CMBOT_STORAGE_KEYS, ...LYACV_STORAGE_KEYS],
      }),
    ),
    KeycloakGnService,
    provideAppInitializer(() => {
      const keycloak = inject(KeycloakGnService);
      return keycloak.init();
    }),
    provideHttpClient(withInterceptors([httpInterceptor])),
    {
      provide: RouterStateSerializer,
      useClass: CustomRouterStateSerializer,
    },
    provideTranslateService({
      lang: 'fr',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
        useHttpBackend: false,
      }),
    }),
    /*{
      provide: APP_INITIALIZER,
      useFactory: () => {
        const keycloak = inject(KeycloakService);
        return () => keycloak.init();
      },
      multi: true,
    },*
    /*provideKeycloak({
      config: {
        url: 'https://1vest-demo-auth.1glink.com',
        realm: '1gnius-integ',
        clientId: '1genius-client-api',
      },
      initOptions: {
        // onLoad: 'login-required',
        onLoad: 'check-sso', // 👈 don’t force login on startup

        //redirectUri: window.location.origin + '/t',
        checkLoginIframe: false,
        ...({ thirdPartyCookies: false } as any),
        pkceMethod: 'S256', // best practice for public SPAs
      },
      // optional: other settings like bearerExcludedUrls, etc
    }),*/
  ],
};
